<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex'; 


const store = useStore();
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isEcommerceStoreEnabled = computed(() => store.getters.isEcommerceStoreEnabled);

const can = (permission) => store.getters.hasPermission(permission);
const canAny = (permissions) => permissions.some((permission) => store.getters.hasPermission(permission));

</script>

<template>
 <div class="sidebar" id="sidebar" :class="$route.meta.sidebarClass">
 <div class="slimScrollDiv">
  <div class="sidebar-inner slimscroll">
<perfect-scrollbar
 class="scroll-area"
 :settings="settings"
 @ps-scroll-y="scrollHanle"
>
 <div id="sidebar-menu" class="sidebar-menu">
<ul>
 <li v-if="isAuthenticated" class="submenu-open">
 <h6 class="submenu-hdr">Main</h6>
 <ul>
  <li v-bind:class="{
active: currentPath == 'index' || currentPath == 'index',
  }" title="Press Ctrl + Alt + D">
<router-link to="index"><vue-feather type="grid"></vue-feather><span> Dashboard <span class="shortcut-text">Ctrl + Alt + D</span></span>
</router-link>
  </li>
 </ul>
 </li>
 <li v-if="can('inventory.view')" class="submenu-open">
 <h6 class="submenu-hdr">Products</h6>
 <ul>
  <li title="Press Ctrl + Alt + I">
<router-link :class="currentPath == 'productlist' || currentPath == 'editproduct'
 ? 'active'
 : 'notactive'
 " to="productlist"><vue-feather type="box"></vue-feather><span>Items <span class="shortcut-text">Ctrl + Alt + I</span></span></router-link>
  </li>
  <li title="Press Ctrl + Alt + C">
<router-link :class="currentPath == 'categorylist' ? 'active' : 'notactive'"
 to="categorylist"><vue-feather type="codepen"></vue-feather><span>Category <span class="shortcut-text">Ctrl + Alt + C</span></span></router-link>
  </li>
  <li>
<router-link :class="currentPath == 'unitlist' || currentPath == 'addunit' || currentPath == 'editunit' ? 'active' : 'notactive'"
 to="unitlist"><vue-feather type="package"></vue-feather><span>Units</span></router-link>
  </li>
 </ul>
 </li>
 <li v-if="isAuthenticated && isEcommerceStoreEnabled" class="submenu-open">
 <h6 class="submenu-hdr">Ecommerce</h6>
 <ul>
  <li>
<router-link :class="currentPath == 'ecommerce-products' ? 'active' : 'notactive'"
 to="ecommerce-products"><vue-feather type="shopping-bag"></vue-feather><span>Products</span></router-link>
  </li>
  <li>
<router-link :class="currentPath == 'ecommerce-orders' ? 'active' : 'notactive'"
 to="ecommerce-orders"><vue-feather type="shopping-cart"></vue-feather><span>Orders</span></router-link>
  </li>
 </ul>
 </li>
 <li v-if="canAny(['sales.view', 'sales.return'])" class="submenu-open">
 <h6 class="submenu-hdr">Sales</h6>
 <ul>
  <li v-if="can('sales.view')" title="Press Ctrl + Alt + O">
<router-link :class="currentPath == 'saleslist' || currentPath == 'sales-details'
 ? 'active'
 : 'notactive'
 " to="saleslist"><vue-feather type="shopping-cart"></vue-feather><span>Sales Invoice <span class="shortcut-text">Ctrl + Alt + O</span></span></router-link>
  </li>
  <li v-if="can('sales.view')">
<router-link :class="currentPath == 'pos' ? 'active' : 'notactive'" to="pos"><vue-feather type="shopping-bag"></vue-feather><span>POS</span></router-link>
  </li>
  <li v-if="can('sales.view')">
<router-link :class="currentPath == 'quotationlist' || currentPath == 'addquotation' || currentPath == 'editquotation'
 ? 'active'
 : 'notactive'
 " to="quotationlist"><vue-feather type="file-text"></vue-feather><span>Quotation</span></router-link>
  </li>
  <li v-if="can('sales.return')">
<router-link :class="currentPath == 'salesreturnlist' || currentPath == 'createsalesreturn' || currentPath == 'editsalesreturn'
 ? 'active'
 : 'notactive'
 " to="salesreturnlist"><vue-feather type="rotate-ccw"></vue-feather><span>Sales Returns</span></router-link>
  </li>
 </ul>
 </li>
 <li v-if="canAny(['purchase.view', 'purchase.return'])" class="submenu-open">
 <h6 class="submenu-hdr">Purchases</h6>
 <ul>
  <li v-if="can('purchase.view')" title="Press Ctrl + Alt + P">
<router-link :class="currentPath == 'purchaselist' || currentPath == 'editpurchase'
 ? 'active'
 : 'notactive'
 " to="purchaselist"><vue-feather
type="shopping-bag"></vue-feather><span>Purchases <span class="shortcut-text">Ctrl + Alt + P</span></span></router-link>
  </li>
  <li v-if="can('purchase.return')">
<router-link :class="currentPath == 'purchasereturnlist' || currentPath == 'createpurchasereturn' || currentPath == 'editpurchasereturn'
 ? 'active'
 : 'notactive'
 " to="purchasereturnlist"><vue-feather
type="corner-up-left"></vue-feather><span>Purchase Returns</span></router-link>
  </li>
 </ul>
 </li>

 <li v-if="canAny(['customer.view', 'supplier.view'])" class="submenu-open">
 <h6 class="submenu-hdr">Peoples</h6>
 <ul>
  <li v-if="can('customer.view')" title="Press Ctrl + Alt + N">
<router-link :class="currentPath == 'customerlist' ? 'active' : 'notactive'"
 to="customerlist"><vue-feather type="user"></vue-feather><span>Customers <span class="shortcut-text">Ctrl + Alt + N</span></span></router-link>
  </li>
  <li v-if="can('supplier.view')" title="Press Ctrl + Alt + S">
<router-link :class="currentPath == 'supplierlist' ? 'active' : 'notactive'"
 to="supplierlist"><vue-feather type="users"></vue-feather><span>Suppliers <span class="shortcut-text">Ctrl + Alt + S</span></span></router-link>
  </li>
 </ul>
 </li>

 <li v-if="can('settings.manage')" class="submenu-open">
 <h6 class="submenu-hdr">Campaigns</h6>
 <ul>
  <li>
<router-link :class="currentPath == 'campaigns' ? 'active' : 'notactive'"
 to="campaigns"><vue-feather type="send"></vue-feather><span>WhatsApp Campaigns</span></router-link>
  </li>
 </ul>
 </li>
 <li v-if="canAny(['finance.ledger.view', 'finance.bank.view', 'expense.view'])" class="submenu-open">
 <h6 class="submenu-hdr">Finance and Account</h6>
 <ul>
  <li v-if="can('finance.ledger.view')">
<router-link :class="currentPath == 'ledger' ? 'active' : 'notactive'"
 to="ledger"><vue-feather type="book-open"></vue-feather><span>Ledger</span></router-link>
  </li>
  <li v-if="can('finance.bank.view')">
<router-link :class="currentPath == 'bank-cheques' ? 'active' : 'notactive'"
 to="bank-cheques"><vue-feather  type="credit-card"></vue-feather><span>Bank &amp; Cheques</span></router-link>
  </li>
  <li v-if="can('expense.view')">
<router-link :class="currentPath == 'expenselist' || currentPath == 'createexpense' || currentPath == 'editexpense'
 ? 'active'
 : 'notactive'
 " to="expenselist"><vue-feather type="credit-card"></vue-feather><span>Expenses</span></router-link>
  </li>
  <li v-if="can('expense.view')">
<router-link :class="currentPath == 'expensecategory' ? 'active' : 'notactive'"
 to="expensecategory"><vue-feather type="tag"></vue-feather><span>Expense Category</span></router-link>
  </li>
 </ul>
 </li>

 <li v-if="canAny(['reports.sales.view', 'reports.purchase.view', 'reports.stock.view', 'reports.tax.view'])" class="submenu-open">
 <h6 class="submenu-hdr">Reports</h6>
 <ul>
  <li v-if="can('reports.sales.view')" title="Press Ctrl + Alt + W">
<router-link :class="currentPath == 'salesreport' ? 'active' : 'notactive'"
 to="salesreport"><vue-feather type="bar-chart-2"></vue-feather><span>Sales
Report <span class="shortcut-text">Ctrl + Alt + W</span></span></router-link>
  </li>
  <li v-if="can('reports.sales.view')">
<router-link :class="currentPath == 'businessreport' ? 'active' : 'notactive'"
 to="businessreport"><vue-feather type="trending-up"></vue-feather><span>Business
Reports</span></router-link>
  </li>
  <li v-if="can('reports.purchase.view')">
<router-link :class="currentPath == 'purchasereport' ? 'active' : 'notactive'"
 to="purchasereport"><vue-feather type="archive"></vue-feather><span>Purchase
Report</span></router-link>
  </li>
  <li v-if="can('reports.stock.view')">
<router-link :class="currentPath == 'inventoryreport' ? 'active' : 'notactive'"
 to="inventoryreport"><vue-feather type="archive"></vue-feather><span>Stock
Report</span></router-link>
  </li>
  <li v-if="can('reports.stock.view')">
<router-link :class="currentPath == 'stockledgerreport' ? 'active' : 'notactive'"
 to="stockledgerreport"><vue-feather type="list"></vue-feather><span>Stock Ledger
Report</span></router-link>
  </li>
  <li v-if="can('reports.tax.view')">
<router-link :class="currentPath == 'gstreport' ? 'active' : 'notactive'"
 to="gstreport"><vue-feather type="file-text"></vue-feather><span>GST / Tax
Report</span></router-link>
  </li>
 </ul>
 </li>

<li v-if="can('settings.manage')" class="submenu-open">
  <h6 class="submenu-hdr">Settings</h6>
  <ul>
    <li>
      <router-link :class="currentPath == 'companysettings' ? 'active' : 'notactive'"
        to="companysettings"><vue-feather type="home"></vue-feather><span>Company Settings</span></router-link>
    </li>
    <li>
      <router-link :class="currentPath == 'taxrates' ? 'active' : 'notactive'"
        to="taxrates"><vue-feather type="percent"></vue-feather><span>HSN Tax Master</span></router-link>
    </li>
  </ul>
</li>

<li v-if="can('settings.manage')" class="submenu-open">
  <h6 class="submenu-hdr">Data Management</h6>
  <ul>
    <li title="Press Ctrl + Alt + U">
      <router-link :class="currentPath == 'dataupload' ? 'active' : 'notactive'"
        to="dataupload">
        <vue-feather type="upload"></vue-feather>
        <span>Upload Data <span class="shortcut-text">Ctrl + Alt + U</span></span>
      </router-link>
    </li>
  </ul>
</li>

<li v-if="canAny(['users.view', 'users.manage_roles'])" class="submenu-open">
  <h6 class="submenu-hdr">Access Control</h6>
  <ul>
    <li v-if="can('users.view')">
      <router-link :class="currentPath == 'userlists' || currentPath == 'newuser' || currentPath == 'newuseredit'
 ? 'active'
 : 'notactive'
 " to="userlists"><vue-feather type="users"></vue-feather><span>Users</span></router-link>
    </li>
    <li v-if="can('users.manage_roles')">
      <router-link :class="currentPath == 'grouppermissions' || currentPath == 'createpermission' || currentPath == 'editpermission'
 ? 'active'
 : 'notactive'
 " to="grouppermissions"><vue-feather type="shield"></vue-feather><span>Roles & Permissions</span></router-link>
    </li>
  </ul>
</li>




</ul>
 </div>
</perfect-scrollbar>
  </div>
 </div>
 </div>
 </template>
<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
export default {
  data() {
    return {
      productMenu: false,
      salesMenu: false,
      purchaseMenu: false,
      expenseMenu: false,
      quotationMenu: false,
      transferMenu: false,
      returnMenu: false,
      peopleMenu: false,
      placesMenu: false,
      errorpageMenu: false,
      reportMenu: false,
      userMenu: false,
      settingMenu: false,
      elementMenu: false,
      chartMenu: false,
      iconMenu: false,
      formMenu: false,
      tableMenu: false,
      chatMenu: false,
      authenticationPageMenu: false,
      settings: {
        suppressScrollX: true,
      },
      activeClass: "active",
      currentPath: this.$route.name,
    };
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      const target = event.target;
      const tagName = target?.tagName?.toLowerCase();
      if (
        target?.isContentEditable ||
        ["input", "textarea", "select"].includes(tagName)
      ) {
        return;
      }

      if (!event.ctrlKey || !event.altKey || event.shiftKey || event.metaKey) {
        return;
      }

      const shortcutRoutes = {
        d: { name: "index" },
        p: { name: "purchaselist", permission: "purchase.view" },
        i: { name: "productlist", permission: "inventory.view" },
        c: { name: "categorylist", permission: "inventory.view" },
        o: { name: "saleslist", permission: "sales.view" },
        w: { name: "salesreport", permission: "reports.sales.view" },
        n: { name: "customerlist", permission: "customer.view" },
        s: { name: "supplierlist", permission: "supplier.view" },
        u: { name: "dataupload", permission: "settings.manage" },
      };
      const route = shortcutRoutes[event.key.toLowerCase()];
      if (!route) {
        return;
      }

      if (route.permission && !this.$store.getters.hasPermission(route.permission)) {
        return;
      }

      event.preventDefault();
      this.$router.push({ name: route.name });
    },
    scrollHanle(evt) { },
    isCustomDropdown() {
      
      var searchOptions = document.getElementById("search-close-options");
      var dropdown = document.getElementById("search-dropdown");
      var searchInput = document.getElementById("search-options");

      searchInput.addEventListener("focus", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchInput.addEventListener("keyup", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchOptions.addEventListener("click", () => {
        searchInput.value = "";
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.getAttribute("id") !== "search-options") {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#sidebar")) {
          let a = document
            .querySelector("#sidebar")
            .querySelector('[href="' + ele + '"]');

          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute(
                "aria-expanded",
                "true"
              );
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .classList.add("show");
                if (
                  parentCollapseDiv.parentElement.closest(".collapse")
                    .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      }, 1000);
    },
  },
  components: {
    PerfectScrollbar,
  },
  watch: {
    $route(to) {
      this.currentPath = to.name;
    }
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
    productMenu() {
      return (
        this.$route.name == "productlist" ||
        this.$route.name == "product-details" ||
        this.$route.name == "addproduct" ||
        this.$route.name == "editproduct" ||
        this.$route.name == "editcategory" ||
        this.$route.name == "categorylist" ||
        this.$route.name == "addcategory" ||
        this.$route.name == "unitlist" ||
        this.$route.name == "addunit" ||
        this.$route.name == "editunit"
      );
    },
    salesMenu() {
      return (
        this.$route.name == "saleslist" ||
        this.$route.name == "sales-details" ||
        this.$route.name == "pos" ||
        this.$route.name == "add-sales" ||
        this.$route.name == "editsalesreturns" ||
        this.$route.name == "edit-sales" ||
        this.$route.name == "salesreturnlists" ||
        this.$route.name == "createsalesreturns"
      );
    },
    purchaseMenu() {
      return (
        this.$route.name == "purchaselist" ||
        this.$route.name == "addpurchase" ||
        this.$route.name == "editpurchase"
      );
    },
    expenseMenu() {
      return (
        this.$route.name == "expenselist" ||
        this.$route.name == "createexpense" ||
        this.$route.name == "editexpense" ||
        this.$route.name == "expensecategory"
      );
    },
    peopleMenu() {
      return (
        this.$route.name == "customerlist" ||
        this.$route.name == "addcustomer" ||
        this.$route.name == "editcustomer" ||
        this.$route.name == "supplierlist" ||
        this.$route.name == "editsupplier" ||
        this.$route.name == "addsupplier"
      );
    },
    reportMenu() {
      return (
        this.$route.name == "inventoryreport" ||
        this.$route.name == "stockledgerreport" ||
        this.$route.name == "salesreport" ||
        this.$route.name == "businessreport" ||
        this.$route.name == "gstreport" ||
        this.$route.name == "supplierreport" ||
        this.$route.name == "dataupload"
      );
    },
    userMenu() {
      return (
        this.$route.name == "newuser" ||
        this.$route.name == "userlists" ||
        this.$route.name == "newuseredit"
      );
    },
    settingMenu() {
      return (
        this.$route.name == "editpermission" ||
        this.$route.name == "createpermission" ||
        this.$route.name == "currencysettings" ||
        this.$route.name == "grouppermissions" ||
        this.$route.name == "taxrates" ||
        this.$route.name == "companysettings"
      );
    },
    tableMenu() {
      return this.$route.name == "tables-basic" || this.$route.name == "data-tables";
    },
    currentPath() {
      return this.$route.name;
    },
  },
};
</script>
<style scoped>
.shortcut-text {
  display: block;
  font-size: 8px; 
  margin-left: 1px;
  color: rgb(161, 161, 161); 
}
</style>
